import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useGoogleAuthRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const user = JSON.parse(params.get('user'));
        const message = params.get('message');
        const userID = params.get('userID');
        const type = params.get('type');
        const login_status = params.get('login_status');
        
        if (message === "unverified") {
            const updatedData = {
                userId: userID,
                userType: type,
                loginStatus: login_status,
            };
            localStorage.setItem('registerData', JSON.stringify(updatedData));
            if (login_status !== "login" && type === "park") {
                navigate('/park/user-type');
            } else {
                navigate('/park/select-age');
            }
        } else if (token) {
            const userData = {
                _id: user._id,
                username: user.username,
                email: user.email,
                profileImage: user.profileImage,
                type: user.type,
                token: token
            };
            localStorage.setItem('limitsUser', JSON.stringify(userData));
            localStorage.removeItem('registerData');
            navigate('/');
        }
    }, [navigate]);

};

export default useGoogleAuthRedirect;
